import { WorkspaceInterface } from 'shared/types/workspace-interface'
import httpClient from 'shared/utils/http-client'

export const WORKSPACE_API = '/api/dashboard/settings/workspace'

export const setWorkspace = (data: WorkspaceInterface) => httpClient.post(WORKSPACE_API, data)
